"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _utils = require("../common/utils.js");

var _Box = _interopRequireDefault(require("../box/Box"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcTag = function DxcTag(_ref) {
  var icon = _ref.icon,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      linkHref = _ref.linkHref,
      onClick = _ref.onClick,
      _ref$iconBgColor = _ref.iconBgColor,
      iconBgColor = _ref$iconBgColor === void 0 ? "#5f249f" : _ref$iconBgColor,
      _ref$labelPosition = _ref.labelPosition,
      labelPosition = _ref$labelPosition === void 0 ? "after" : _ref$labelPosition,
      _ref$newWindow = _ref.newWindow,
      newWindow = _ref$newWindow === void 0 ? false : _ref$newWindow,
      margin = _ref.margin,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "fitContent" : _ref$size,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;
  var colorsTheme = (0, _useTheme["default"])();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isHovered = _useState2[0],
      changeIsHovered = _useState2[1];

  var clickHandler = function clickHandler() {
    onClick && onClick();
  };

  var tagContent = /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    size: size,
    shadowDepth: isHovered && (onClick || linkHref) && 2 || 1
  }, /*#__PURE__*/_react["default"].createElement(TagContent, {
    labelPosition: labelPosition
  }, labelPosition === "before" && size !== "small" && label && /*#__PURE__*/_react["default"].createElement(TagLabel, null, label), icon && /*#__PURE__*/_react["default"].createElement(IconContainer, {
    iconBgColor: iconBgColor
  }, typeof icon === "string" ? /*#__PURE__*/_react["default"].createElement(TagIcon, {
    src: icon
  }) : icon), labelPosition === "after" && size !== "small" && label && /*#__PURE__*/_react["default"].createElement(TagLabel, null, label)));

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.tag
  }, /*#__PURE__*/_react["default"].createElement(StyledDxcTag, {
    margin: margin,
    size: size,
    onMouseEnter: function onMouseEnter() {
      return changeIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return changeIsHovered(false);
    },
    onClick: clickHandler,
    hasAction: onClick || linkHref
  }, onClick ? /*#__PURE__*/_react["default"].createElement(StyledButton, {
    tabIndex: tabIndex
  }, tagContent) : linkHref ? /*#__PURE__*/_react["default"].createElement(StyledLink, {
    tabIndex: tabIndex,
    href: linkHref,
    target: newWindow ? "_blank" : "_self"
  }, tagContent) : tagContent));
};

var sizes = {
  small: "42px",
  medium: "240px",
  large: "480px",
  fillParent: "100%",
  fitContent: "fit-content"
};

var calculateWidth = function calculateWidth(margin, size) {
  return size === "fillParent" ? "calc(".concat(sizes[size], " - ").concat((0, _utils.getMargin)(margin, "left"), " - ").concat((0, _utils.getMargin)(margin, "right"), ")") : sizes[size];
};

var StyledDxcTag = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  cursor: ", ";\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  width: ", ";\n  height: ", ";\n"])), function (_ref2) {
  var hasAction = _ref2.hasAction;
  return hasAction && "pointer" || "unset";
}, function (_ref3) {
  var margin = _ref3.margin;
  return margin && (0, _typeof2["default"])(margin) !== "object" ? _variables.spaces[margin] : "0px";
}, function (_ref4) {
  var margin = _ref4.margin;
  return margin && margin.top ? _variables.spaces[margin.top] : "";
}, function (_ref5) {
  var margin = _ref5.margin;
  return margin && margin.right ? _variables.spaces[margin.right] : "";
}, function (_ref6) {
  var margin = _ref6.margin;
  return margin && margin.bottom ? _variables.spaces[margin.bottom] : "";
}, function (_ref7) {
  var margin = _ref7.margin;
  return margin && margin.left ? _variables.spaces[margin.left] : "";
}, function (props) {
  return calculateWidth(props.margin, props.size);
}, function (props) {
  return props.theme.height;
});

var TagContent = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n  height: ", ";\n"])), function (props) {
  return props.theme.height;
});

var StyledLink = _styledComponents["default"].a(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  text-decoration: none;\n  border-radius: 4px;\n  width: 100%;\n  :focus {\n    outline: 2px solid ", ";\n    outline-offset: 0px;\n  }\n"])), function (props) {
  return props.theme.focusColor;
});

var StyledButton = _styledComponents["default"].button(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  background: none;\n  border-radius: 4px;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-family: inherit;\n  width: 100%;\n  :focus {\n    outline: 2px solid ", ";\n  }\n"])), function (props) {
  return props.theme.focusColor;
});

var IconContainer = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  background: ", ";\n  width: ", ";\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  color: ", ";\n  min-width: ", ";\n  overflow: hidden;\n  img,\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (_ref8) {
  var iconBgColor = _ref8.iconBgColor;
  return iconBgColor;
}, function (props) {
  return props.theme.iconSectionWidth;
}, function (props) {
  return props.theme.iconColor;
}, function (props) {
  return props.theme.iconSectionWidth;
}, function (props) {
  return props.theme.iconWidth;
}, function (props) {
  return props.theme.iconHeight;
});

var TagIcon = _styledComponents["default"].img(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])([""])));

var TagLabel = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  color: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  flex-grow: 1;\n  text-align: center;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"])), function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.fontSize;
}, function (props) {
  return props.theme.fontStyle;
}, function (props) {
  return props.theme.fontWeight;
}, function (props) {
  return props.theme.fontColor;
}, function (props) {
  return props.theme.labelPaddingTop;
}, function (props) {
  return props.theme.labelPaddingBottom;
}, function (props) {
  return props.theme.labelPaddingLeft;
}, function (props) {
  return props.theme.labelPaddingRight;
});

var _default = DxcTag;
exports["default"] = _default;